<template>
    <expo-matching-state
        v-bind="{
            value,
            program,
            employee,
            employer,
            isUserHost,
            isUserEmployee,
            isUserEmployer,
        }"
        @input="pushMatchings"
    />
</template>

<script>
import { initExpoEmployee, initExpoProgram } from "@/assets/variables";

import ExpoMatchingState from "@/components/client/expo/matching/expo-matching-state.vue";
import { mapMutations, mapState } from "vuex";

export default {
    components: {
        ExpoMatchingState,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
        employee: { type: Object, default: initExpoEmployee },
        isUserHost: { type: Boolean, default: false },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        ...mapState("expo", ["employer", "matchings"]),

        value() {
            return this.matchings.find(({ _employee }) => _employee == this.employee._id);
        },
    },
    methods: {
        ...mapMutations("expo", ["pushMatchings"]),
    },
};
</script>

<style>
</style>